exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:767px) {\n  .mat-dialog-content-ovh {\n    overflow: auto !important;\n  }\n}\n\n.btnAcquista,\n.btnAnnulla {\n  background-color: #ffffff;\n  border: 1px solid #5daada;\n  height: 50px;\n  width: 140px; \n  border-radius: 0;\n  margin-bottom: 10px;\n}\n\n.btnAcquista:hover,\n.btnAnnulla:hover {\n  background-color: #ffffff;\n  border: 1px solid #5daada;\n  border: 3px solid #f47920;\n  font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-invia-messaggio-servizio/dialog-invia-messaggio-servizio.component.css
// module id = ../../../../../src/app/components/utilita/dialogs/dialog-invia-messaggio-servizio/dialog-invia-messaggio-servizio.component.css
// module chunks = main